"use client";

import { useLoaderMotion } from "@/components/site/motion/useChromeMotion";
import { useMotion } from "@/components/site/motion/MotionContext";
import { BrandLoaderMark } from "@/components/icons/SiteMarks";

export function Loader() {
  useLoaderMotion(useMotion());

  return (
    <div className="site_loader full_page f a-c j-c" id="loader">
      {/* Always LTR: X + "attir" must match English splash under html[dir=rtl]. */}
      <div className="loader_logo ltr_island f a-b" dir="ltr">
        <BrandLoaderMark />
      </div>
    </div>
  );
}
